(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[168],{

/***/ "1w3z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/tracking/track-page/TrackPage.jsx
var TrackPage = __webpack_require__("tZiC");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/widgets/prebooking-form/CustomerLogin.jsx
var CustomerLogin = __webpack_require__("ZQ8D");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTrackEvent.js
var useTrackEvent = __webpack_require__("DqI1");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/ScrollToErrorHook.js
var ScrollToErrorHook = __webpack_require__("I7/a");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 14 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.constants.js
var PrebookingForm_constants = __webpack_require__("FaX5");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormCompanion.jsx

var __jsx = react_default.a.createElement;







var PrebookingFormCompanion_PrebookingFormCompanion = function PrebookingFormCompanion(_ref) {
  var companionGroup = _ref.companionGroup,
      dateFormat = _ref.dateFormat,
      hasUnicodeFields = _ref.hasUnicodeFields,
      index = _ref.index,
      civilities = _ref.civilities,
      birthday = _ref.birthday;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var showUnicodeFieldsFirst = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('prebooking.unicodeFieldsFirst');
  var formHeader = companionGroup === PrebookingForm_constants["b" /* COMPANION_GROUPS */].ADULTS ? "".concat(Object(i18n["h" /* t */])('prebookingForm.pax.adultCompanionLabel'), " ").concat(index + 1) : "".concat(Object(i18n["h" /* t */])('prebookingForm.pax.childCompanionLabel'), " ").concat(birthday ? moment_default()(birthday).format(dateFormat) : '');
  return __jsx("div", {
    className: "flex flex-wrap"
  }, __jsx("p", {
    className: "mb-10 w-full px-10 text-14 font-bold"
  }, formHeader), __jsx("div", {
    className: "w-full"
  }, __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-civility-field"),
    hideErrorMessage: true,
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".civility"),
    options: civilities,
    placeholder: "".concat(Object(i18n["h" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'), "*"),
    type: "select"
  }))), hasUnicodeFields && showUnicodeFieldsFirst && __jsx(react["Fragment"], null, __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstNameUnicode-field"),
    hideErrorMessage: true,
    name: "".concat(companionGroup, ".").concat(index, ".firstNameUnicode"),
    optimized: true,
    isRequired: true,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastNameUnicode-field"),
    hideErrorMessage: true,
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastNameUnicode"),
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstName-field"),
    hideErrorMessage: true,
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".firstName"),
    optimized: true,
    placeholder: "".concat(Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'), "*"),
    type: "text"
  })), __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastName-field"),
    hideErrorMessage: true,
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastName"),
    optimized: true,
    placeholder: "".concat(Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'), "*"),
    type: "text"
  })), hasUnicodeFields && !showUnicodeFieldsFirst && __jsx(react["Fragment"], null, __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstNameUnicode-field"),
    hideErrorMessage: true,
    name: "".concat(companionGroup, ".").concat(index, ".firstNameUnicode"),
    optimized: true,
    isRequired: true,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastNameUnicode-field"),
    hideErrorMessage: true,
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastNameUnicode"),
    optimized: true,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), companionGroup === PrebookingForm_constants["b" /* COMPANION_GROUPS */].ADULTS && __jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, __jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-birthdate-field"),
    hideErrorMessage: true,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    name: "".concat(companionGroup, ".").concat(index, ".birthdate"),
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormTravelInformations.jsx






var PrebookingFormTravelInformations_jsx = react_default.a.createElement;










var PrebookingFormTravelInformations_PrebookingFormTravelInformations = function PrebookingFormTravelInformations(_ref) {
  var agencies = _ref.agencies,
      civilities = _ref.civilities,
      dateFormat = _ref.dateFormat,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      consentOptins = _ref.consentOptins;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      initialValues = _useFormikContext.initialValues;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var hasLoggedUserBirthdate = hasUser && !!initialValues.traveler.birthdate;
  var hasLoggedUserPhone = hasUser && !!initialValues.traveler.phone;
  var adults = values.adults,
      adultsNumber = values.adultsNumber,
      kids = values.kids,
      kidsNumber = values.kidsNumber;
  var optinEmail = consentOptins.optinEmail,
      optinPhone = consentOptins.optinPhone,
      optinSms = consentOptins.optinSms,
      optinProfile = consentOptins.optinProfile;
  var adultsInt = parseInt(adultsNumber, 10);
  var kidsInt = parseInt(kidsNumber, 10);
  var hasAddtionnalTravelers = adultsInt > 1 || kidsInt > 0;
  var showUnicodeFieldsFirst = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('prebooking.unicodeFieldsFirst');
  return PrebookingFormTravelInformations_jsx("div", {
    id: "pbf-step-2",
    "data-testid": "prebooking-form-form-travel-informations"
  }, PrebookingFormTravelInformations_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4",
    id: "pbf-step-2-title"
  }, Object(i18n["h" /* t */])('prebookingForm.mainTraveler.title')), PrebookingFormTravelInformations_jsx("p", {
    className: "text-12all m-0 mb-10 px-10"
  }, Object(i18n["h" /* t */])('prebookingForm.mandatoryFieldsInformation')), PrebookingFormTravelInformations_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormTravelInformations_jsx("div", {
    className: "w-full"
  }, PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-civility-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'),
    name: "traveler.civility",
    options: civilities.adults,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'),
    type: "select"
  }))), hasUnicodeFields && showUnicodeFieldsFirst && PrebookingFormTravelInformations_jsx(react["Fragment"], null, PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    name: "traveler.firstNameUnicode",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    name: "traveler.lastNameUnicode",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstName-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'),
    name: "traveler.firstName",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'),
    type: "text"
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastName-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'),
    name: "traveler.lastName",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'),
    type: "text"
  })), hasUnicodeFields && !showUnicodeFieldsFirst && PrebookingFormTravelInformations_jsx(react["Fragment"], null, PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    name: "traveler.firstNameUnicode",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    name: "traveler.lastNameUnicode",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-birthdate-field",
    hideErrorMessage: true,
    isDisabled: hasLoggedUserBirthdate,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    name: "traveler.birthdate",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-gm-number-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.gmNumberPlaceholder'),
    name: "traveler.memberNumber",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.gmNumberPlaceholder'),
    type: "text"
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-email-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.emailPlaceholder'),
    name: "traveler.email",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.emailPlaceholder'),
    type: "text"
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full"
  }, PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-phone-field",
    hideErrorMessage: true,
    isDisabled: hasLoggedUserPhone,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.phoneNumberPlaceholder'),
    name: "traveler.phone",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.phoneNumberPlaceholder'),
    type: "text"
  }))), agencies.length > 1 && PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-agency-field",
    hideErrorMessage: true,
    label: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.favoriteTravelAgencyLabel'),
    name: "agency",
    options: agencies,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.favoriteTravelAgencyPlaceholder'),
    type: "select"
  })), hasAddtionnalTravelers && PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10"
  }, adults.map(function (adult, index) {
    return PrebookingFormTravelInformations_jsx(PrebookingFormCompanion_PrebookingFormCompanion, {
      key: "adult-".concat(index),
      companionGroup: PrebookingForm_constants["a" /* ADULTS */],
      dateFormat: dateFormat,
      civilities: civilities.adults,
      hasUnicodeFields: hasUnicodeFields,
      index: index
    });
  }), kids.map(function (kid, index) {
    return PrebookingFormTravelInformations_jsx(PrebookingFormCompanion_PrebookingFormCompanion, {
      key: "kid-".concat(index),
      companionGroup: PrebookingForm_constants["c" /* KIDS */],
      dateFormat: dateFormat,
      civilities: civilities.kids,
      hasUnicodeFields: hasUnicodeFields,
      index: index,
      birthday: kid.birthdate
    });
  })), PrebookingFormTravelInformations_jsx("div", {
    className: "w-full p-10"
  }, PrebookingFormTravelInformations_jsx("p", {
    className: "mb-10 w-full text-14 font-bold"
  }, Object(i18n["h" /* t */])('prebookingForm.mainTraveler.optinCommunicationsInformation')), optinEmail && PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    dataTestId: "optin-email-field",
    label: optinEmail.title,
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), optinPhone && PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    dataTestId: "optin-phone-field",
    label: optinPhone.title,
    name: "optinPhone",
    optimized: true,
    type: "checkbox"
  }), optinSms && PrebookingFormTravelInformations_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-10",
    dataTestId: "optin-sms-field",
    label: optinSms.title,
    name: "optinSms",
    optimized: true,
    type: "checkbox"
  }), optinEmail && optinEmail.description && PrebookingFormTravelInformations_jsx(Text["a" /* Text */], {
    className: "mt-15",
    theme: "text-sans-n2",
    text: optinEmail.description
  }), optinProfile && optinProfile.description && PrebookingFormTravelInformations_jsx(Text["a" /* Text */], {
    className: "mt-15",
    theme: "text-sans-n2",
    text: optinProfile.description
  }))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/TabLikeFilters.jsx


var TabLikeFilters_jsx = react_default.a.createElement;


var TabLikeFilters_TabLikeFilters = function TabLikeFilters(_ref) {
  var options = _ref.options,
      _ref$selectedValue = _ref.selectedValue,
      selectedValue = _ref$selectedValue === void 0 ? null : _ref$selectedValue,
      onChange = _ref.onChange,
      additionalClassNames = _ref.additionalClassNames,
      dataTestId = _ref.dataTestId;

  var handleClick = function handleClick(value) {
    if (selectedValue === value) {
      onChange(null);
    } else {
      onChange(value);
    }
  };

  return TabLikeFilters_jsx("div", {
    className: Object(classnames_utils["a" /* classnames */])('flex flex-wrap', additionalClassNames),
    "data-testid": dataTestId,
    role: "group"
  }, options.map(function (option) {
    var isActive = selectedValue === option.value;
    return TabLikeFilters_jsx("div", {
      key: option.value,
      className: "w-full p-10 md:w-1/2"
    }, TabLikeFilters_jsx("button", {
      type: "button",
      onClick: function onClick() {
        return handleClick(option.value);
      },
      className: Object(classnames_utils["a" /* classnames */])('font-medium duration-200 w-full rounded-24 px-15 py-10 text-14 transition-all', 'focus:ring-2 focus:ring-black focus:ring-offset-2 border border-black focus:outline-none', {
        'bg-black text-white': isActive,
        'hover:bg-gray-50 bg-white text-black': !isActive
      }),
      "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(option.value) : undefined,
      "aria-pressed": isActive
    }, option.label));
  }));
};
// EXTERNAL MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.utils.js
var PrebookingFormLine_utils = __webpack_require__("chol");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("ssvU");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/omit.js
var omit = __webpack_require__("uZih");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.utils.js





















function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(defineProperty["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










 // Map Traveler in User Context

var PrebookingForm_utils_getDateTimestamp = function getDateTimestamp(birthdate) {
  return moment_default()(birthdate).valueOf();
};

var getFormUser = function getFormUser(user) {
  var _user$civility = user.civility,
      civility = _user$civility === void 0 ? '' : _user$civility,
      dateOfBirth = user.dateOfBirth,
      _user$email = user.email,
      email = _user$email === void 0 ? '' : _user$email,
      _user$firstName = user.firstName,
      firstName = _user$firstName === void 0 ? '' : _user$firstName,
      _user$GMNumber = user.GMNumber,
      GMNumber = _user$GMNumber === void 0 ? '' : _user$GMNumber,
      _user$lastName = user.lastName,
      lastName = _user$lastName === void 0 ? '' : _user$lastName,
      _user$mobilePhoneNumb = user.mobilePhoneNumber,
      mobilePhoneNumber = _user$mobilePhoneNumb === void 0 ? '' : _user$mobilePhoneNumb,
      unicodeFirstName = user.unicodeFirstName,
      unicodeLastName = user.unicodeLastName;
  return {
    civility: civility,
    birthdate: dateOfBirth ? PrebookingForm_utils_getDateTimestamp(dateOfBirth) : null,
    email: email,
    firstName: firstName,
    firstNameUnicode: unicodeFirstName,
    memberNumber: GMNumber,
    lastName: lastName,
    lastNameUnicode: unicodeLastName,
    phone: mobilePhoneNumber
  };
};
var getFormOptins = function getFormOptins(userInfo, consentOptins) {
  var _consentOptins$optinE, _consentOptins$optinP, _consentOptins$optinS;

  return {
    optinEmail: 'optinEmail' in userInfo ? userInfo.optinEmail || false : ((_consentOptins$optinE = consentOptins.optinEmail) === null || _consentOptins$optinE === void 0 ? void 0 : _consentOptins$optinE.preChecked) || false,
    optinPhone: 'optinPhone' in userInfo ? userInfo.optinPhone || false : ((_consentOptins$optinP = consentOptins.optinPhone) === null || _consentOptins$optinP === void 0 ? void 0 : _consentOptins$optinP.preChecked) || false,
    optinSms: 'optinSms' in userInfo ? userInfo.optinSms || false : ((_consentOptins$optinS = consentOptins.optinSms) === null || _consentOptins$optinS === void 0 ? void 0 : _consentOptins$optinS.preChecked) || false
  };
}; // Initialize Form

var PrebookingForm_utils_getInitialFormValues = function getInitialFormValues(initialFormData) {
  var traveler = initialFormData.traveler,
      productId = initialFormData.productId,
      optinEmail = initialFormData.optinEmail,
      optinPhone = initialFormData.optinPhone,
      optinSms = initialFormData.optinSms;
  return {
    accommodation: '',
    accommodationCategory: '000022',
    adults: [{
      birthdate: null,
      civility: '',
      firstName: '',
      lastName: ''
    }],
    adultsNumber: '2',
    agency: '',
    departureCity: 'NO',
    departureDate: {
      from: null,
      to: null
    },
    duration: '',
    kids: [],
    kidsNumber: PrebookingForm_constants["g" /* MIN_FORM_KIDS */].toString(),
    optinEmail: optinEmail,
    optinPhone: optinPhone,
    optinSms: optinSms,
    productId: productId,
    traveler: traveler
  };
}; // Set Form Schema
// Birthdate from 1920

var minBirthdateTimestamp = moment_default()('1920-01-01').valueOf(); // Birthdate less than 18 years old

var kidBirthdateTimestamp = moment_default()().subtract(18, 'years').valueOf();
var adultBirthdateSchema = lib["number"]().min(minBirthdateTimestamp).max(kidBirthdateTimestamp).nullable();
var getAdultBirthdateValidator = function getAdultBirthdateValidator() {
  return adultBirthdateSchema;
};
var PrebookingForm_utils_getKidFutureBithdateValidator = function getKidFutureBithdateValidator(minAuthorizedAgeInMonths) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';
  return lib["number"]().transform(function (value) {
    return Number.isNaN(value) ? undefined : value;
  }).test('isOldEnough', errorMessage, function (value) {
    var context = this.options.context;

    if (value && (context === null || context === void 0 ? void 0 : context.values.departureDate.from)) {
      var departureDate = moment_default()(context === null || context === void 0 ? void 0 : context.values.departureDate.from).startOf('day');
      var kidBirthdate = moment_default()(value).startOf('day');
      var validBirthdate = kidBirthdate.isBefore(departureDate);

      if (minAuthorizedAgeInMonths) {
        var minAuthorizedMoment = departureDate.subtract(minAuthorizedAgeInMonths, 'months');
        return validBirthdate && kidBirthdate.isBefore(minAuthorizedMoment);
      }

      return validBirthdate;
    }

    return false;
  }).nullable().required();
};
var PrebookingForm_utils_getFormSchema = function getFormSchema(t, _ref, formStep) {
  var agencies = _ref.agencies,
      civilities = _ref.civilities,
      locale = _ref.locale,
      productIds = _ref.productIds;
  var agencySchema = lib["mixed"]().oneOf(agencies).required();
  var fistNameSchema = lib["string"]().required(t('prebookingForm.mainTraveler.firstNamePlaceholder')).max(20, t('prebookingForm.mainTraveler.firstNamePlaceholder'));
  var lastNameSchema = lib["string"]().required(t('prebookingForm.mainTraveler.firstNamePlaceholder')).max(30, t('prebookingForm.mainTraveler.firstNamePlaceholder'));
  var adultCivilities = civilities.adults.map(function (civility) {
    return civility.value;
  });
  var kidCivilities = civilities.kids.map(function (civility) {
    return civility.value;
  });
  var adultCompanionSchema = lib["object"]().shape({
    civility: lib["mixed"]().oneOf(adultCivilities).required(),
    birthdate: adultBirthdateSchema,
    firstName: fistNameSchema,
    lastName: lastNameSchema
  });
  var kidCompanionSchema = lib["object"]().shape({
    civility: lib["mixed"]().oneOf(kidCivilities),
    birthdate: lib["number"]().min(kidBirthdateTimestamp).nullable().required(),
    firstName: fistNameSchema,
    lastName: lastNameSchema
  });
  var kidBirthdaySchema = lib["object"]().shape({
    birthdate: lib["number"]().transform(function (value) {
      return Number.isNaN(value) ? undefined : value;
    }).min(kidBirthdateTimestamp).nullable().required(t('prebookingForm.pax.childCompanionErrorLabel'))
  });
  var travelerSchema = lib["object"]().shape({
    birthdate: adultBirthdateSchema,
    civility: lib["mixed"]().oneOf(adultCivilities).required(),
    email: lib["string"]().email(t('prebookingForm.mainTraveler.emailPlaceholder')).required(t('prebookingForm.mainTraveler.emailPlaceholder')),
    firstName: fistNameSchema,
    lastName: lastNameSchema,
    memberNumber: lib["string"]().matches(CommonValidators["a" /* GM_NUMBER_PATTERN */]),
    phone: lib["string"]().required(t('prebookingForm.mainTraveler.phonePlaceholder')).matches(Object(RegexHelper["b" /* getPhoneRegex */])(locale), {
      excludeEmptyString: true,
      message: t('prebookingForm.mainTraveler.phonePlaceholder')
    })
  });

  var returnFullSchema = function returnFullSchema() {
    return lib["object"]().shape(_objectSpread(_objectSpread({
      accommodationCategory: lib["string"]().required(),
      adults: lib["array"]().min(PrebookingForm_constants["f" /* MIN_FORM_ADULTS */] - 1).max(PrebookingForm_constants["d" /* MAX_FORM_ADULTS */] - 1).of(adultCompanionSchema),
      adultsNumber: lib["string"]().required()
    }, agencies.length ? {
      agency: agencySchema
    } : null), {}, {
      departureCity: lib["string"]().required(),
      departureDate: lib["object"]().shape({
        from: lib["date"](),
        to: lib["date"]().nullable()
      }).required(),
      duration: lib["string"]().required().matches(/^[0-9]{1,2}$/),
      // 1 or 2 digits
      kids: lib["array"]().min(PrebookingForm_constants["g" /* MIN_FORM_KIDS */]).max(PrebookingForm_constants["e" /* MAX_FORM_KIDS */]).of(kidCompanionSchema),
      kidsNumber: lib["string"]().required(),
      optinEmail: lib["boolean"](),
      optinPhone: lib["boolean"](),
      optinSms: lib["boolean"](),
      productId: lib["mixed"]().oneOf(productIds).required(),
      traveler: travelerSchema
    }));
  };

  switch (formStep) {
    case 0:
      return lib["object"]().shape({
        accommodationCategory: lib["string"]().required(),
        adultsNumber: lib["string"]().required(),
        departureCity: lib["string"]().required(),
        departureDate: lib["object"]().shape({
          from: lib["date"](),
          to: lib["date"]().nullable()
        }).required(),
        duration: lib["string"]().required().matches(/^[0-9]{1,2}$/),
        // 1 or 2 digits
        kids: lib["array"]().min(PrebookingForm_constants["g" /* MIN_FORM_KIDS */]).max(PrebookingForm_constants["e" /* MAX_FORM_KIDS */]).of(kidBirthdaySchema),
        kidsNumber: lib["string"]().required(),
        productId: lib["mixed"]().oneOf(productIds).required()
      });

    default:
      return returnFullSchema();
  }
}; // Submit prebooking form

var PrebookingForm_utils_formatDate = function formatDate(date) {
  return Object(apiDate["m" /* momentToApiDate */])(moment_default()(date));
};

var getCompanionQuery = function getCompanionQuery(companion) {
  var birthdate = companion.birthdate,
      civility = companion.civility,
      firstName = companion.firstName,
      _companion$firstNameU = companion.firstNameUnicode,
      firstNameUnicode = _companion$firstNameU === void 0 ? '' : _companion$firstNameU,
      lastName = companion.lastName,
      _companion$lastNameUn = companion.lastNameUnicode,
      lastNameUnicode = _companion$lastNameUn === void 0 ? '' : _companion$lastNameUn;
  return "{\n    ".concat(birthdate ? "birthdate: \"".concat(PrebookingForm_utils_formatDate(birthdate), "\"") : '', "\n    civility: \"").concat(civility, "\"\n    lastName: \"").concat(lastName, "\"\n    unicodeLastName: \"").concat(lastNameUnicode, "\"\n    firstName: \"").concat(firstName, "\"\n    unicodeFirstName: \"").concat(firstNameUnicode, "\"\n  }");
};

var getCompanionsQuery = function getCompanionsQuery(companions) {
  return companions.reduce(function (acc, companion) {
    return "".concat(acc).concat(getCompanionQuery(companion));
  }, '');
};

var getPrebookingFormQuery = function getPrebookingFormQuery(values, proposalId, proposalPrice) {
  var accommodation = values.accommodation,
      accommodationCategory = values.accommodationCategory,
      adults = values.adults,
      agency = values.agency,
      departureCity = values.departureCity,
      departureDate = values.departureDate,
      duration = values.duration,
      kids = values.kids,
      optinEmail = values.optinEmail,
      optinPhone = values.optinPhone,
      optinSms = values.optinSms,
      productId = values.productId,
      traveler = values.traveler;
  var birthdate = traveler.birthdate,
      civility = traveler.civility,
      email = traveler.email,
      firstName = traveler.firstName,
      _traveler$firstNameUn = traveler.firstNameUnicode,
      firstNameUnicode = _traveler$firstNameUn === void 0 ? '' : _traveler$firstNameUn,
      lastName = traveler.lastName,
      _traveler$lastNameUni = traveler.lastNameUnicode,
      lastNameUnicode = _traveler$lastNameUni === void 0 ? '' : _traveler$lastNameUni,
      _traveler$memberNumbe = traveler.memberNumber,
      memberNumber = _traveler$memberNumbe === void 0 ? '' : _traveler$memberNumbe,
      phone = traveler.phone;
  var price = proposalPrice ? "{ amount: ".concat(proposalPrice.amount, ", currency: \"").concat(proposalPrice.currency, "\" }") : 'null';
  return "mutation {\n    prebooking(\n      productId: \"".concat(productId, "\"\n      proposalId: ").concat(proposalId ? "\"".concat(proposalId, "\"") : 'null', "\n      price: ").concat(price, "\n      departureCity: \"").concat(departureCity, "\"\n      departureDate: \"").concat(PrebookingForm_utils_formatDate(departureDate.from || Date.now()), "\"\n      duration: ").concat(parseInt(duration, 10), "\n      accommodation: ").concat(accommodation ? "\"".concat(accommodation, "\"") : 'null', "\n      accommodationCategory: \"").concat(accommodationCategory, "\"\n      agency: ").concat(agency ? "\"".concat(agency, "\"") : 'null', "\n      mainContact: {\n        gmNumber: \"").concat(memberNumber, "\"\n        civility: \"").concat(civility, "\"\n        lastName: \"").concat(lastName, "\"\n        unicodeLastName: \"").concat(lastNameUnicode, "\"\n        firstName: \"").concat(firstName, "\"\n        unicodeFirstName: \"").concat(firstNameUnicode, "\"\n        ").concat(birthdate ? "birthdate: \"".concat(PrebookingForm_utils_formatDate(birthdate), "\"") : '', "\n        email: \"").concat(email, "\"\n        mobile: \"").concat(phone, "\"\n        ").concat(typeof optinSms !== 'undefined' ? "optinSms: ".concat(optinSms.toString()) : '', "\n        ").concat(typeof optinPhone !== 'undefined' ? "optinPhone: ".concat(optinPhone.toString()) : '', "\n        ").concat(typeof optinEmail !== 'undefined' ? "optinEmail: ".concat(optinEmail.toString()) : '', "\n      }\n      adults: [").concat(getCompanionsQuery(adults), "]\n      children: [").concat(getCompanionsQuery(kids), "]\n    ) {\n      errors {\n        errorKey\n        errorCode\n      }\n      neolaneID\n    }\n  }");
};
var handleSubmit = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, params) {
    var appContext, redirects, router, setHasError, proposalId, trackClickEvent, proposalPrice, formattedPrice, successUrl, prebookingFormQuery, queryParams, _yield$graphQLClient$, prebooking, requestHasSucceeded, redirectUri;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = params.appContext, redirects = params.redirects, router = params.router, setHasError = params.setHasError, proposalId = params.proposalId, trackClickEvent = params.trackClickEvent, proposalPrice = params.proposalPrice;
            formattedPrice = proposalPrice ? {
              amount: proposalPrice.total.value,
              currency: proposalPrice.currency
            } : undefined;
            successUrl = redirects.successUrl;
            prebookingFormQuery = getPrebookingFormQuery(values, proposalId, formattedPrice);
            queryParams = omit_default()(router.query, ['dynamicPage']);
            trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
              detail_click: 'submit_my_request'
            });
            _context.prev = 6;
            _context.next = 9;
            return graphqlClient["a" /* default */].runNoCacheQuery(prebookingFormQuery, appContext, {
              requestName: requestDictionary["V" /* CUSTOMER_BOOKING_PREBOOKING_FORM_SUBMIT */]
            });

          case 9:
            _yield$graphQLClient$ = _context.sent;
            prebooking = _yield$graphQLClient$.prebooking; // Redirect

            requestHasSucceeded = prebooking.errors.length === 0;

            if (requestHasSucceeded) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", setHasError(true));

          case 14:
            redirectUri = successUrl;
            return _context.abrupt("return", router.push(new URI_default.a(redirectUri).query(_objectSpread(_objectSpread({}, queryParams), {}, {
              trackingPageLoadAppendSuffix: values.productId,
              proposalId: proposalId
            })).toString()));

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](6);
            trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
              detail_click: 'request_unsuccessfull'
            });
            return _context.abrupt("return", setHasError(true));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 18]]);
  }));

  return function handleSubmit(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormProject.jsx




















var PrebookingFormProject_jsx = react_default.a.createElement;

function PrebookingFormProject_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingFormProject_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingFormProject_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingFormProject_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















var DEFAULT_COMPANION = {
  birthdate: null,
  civility: '',
  firstName: '',
  lastName: ''
};
var PrebookingFormProject_PrebookingFormProject = function PrebookingFormProject(_ref) {
  var _sortedOpeningDates$, _sortedOpeningDates;

  var adultsOptions = _ref.adultsOptions,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      kidsOptions = _ref.kidsOptions,
      productOptions = _ref.productOptions,
      product = _ref.product,
      products = _ref.products,
      isDisabled = _ref.isDisabled;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setValues = _useFormikContext.setValues,
      setFieldValue = _useFormikContext.setFieldValue;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var transportFeatureFlip = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('prebooking.transport');
  var showFiltersSunSnow = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('prebooking.showFiltersSunSnow');
  var productId = values.productId,
      adults = values.adults,
      adultsNumber = values.adultsNumber,
      kids = values.kids,
      kidsNumber = values.kidsNumber; // Local state for filtering UI (not sent with form)

  var _useState = Object(react["useState"])(null),
      productFilterType = _useState[0],
      setProductFilterType = _useState[1];

  var filteredProductOptions = Object(react["useMemo"])(function () {
    if (!showFiltersSunSnow || !productFilterType) {
      return productOptions;
    } // Flow refinement: productFilterType is ProductFilter at this point


    var filter = productFilterType;
    var filteredProducts = Object(PrebookingFormLine_utils["a" /* filterProductsByType */])(products, filter);
    var filteredProductIds = Object.keys(filteredProducts);
    return productOptions.filter(function (option) {
      return option.value === null || filteredProductIds.includes(option.value);
    });
  }, [showFiltersSunSnow, productFilterType, productOptions, products]);
  Object(react["useEffect"])(function () {
    if (showFiltersSunSnow && productId && productFilterType) {
      var currentProduct = products[productId];
      var filter = productFilterType;

      if (filter === 'sun' && !(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.sun) || filter === 'snow' && !(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.snow)) {
        setFieldValue('productId', '');
      }
    }
  }, [showFiltersSunSnow, productFilterType, productId, products, setFieldValue]);
  var minAuthorizedAge = product ? product.minAuthorizedAge : undefined;
  var isSki = product ? product.isSki : undefined;
  var isSAFC = product ? product.productId === 'SAFC' : undefined;
  var isCOLC = product ? product.productId === 'COLC' : undefined;
  var isCSCK = product ? product.productId === 'CSKC' : undefined;
  var isBOKC = product ? product.productId === 'BOKC' : undefined;
  var minAuthorizedAgeInMonths = product ? product.minAuthorizedAgeInMonths : 0;
  var durationOptions = product ? product.durations : [];
  var transportOptions = product ? product.transports : [];
  var accommodationCategoryOptions = product ? product.accommodations : [];
  var adultsInt = parseInt(adultsNumber, 10);
  var kidsInt = parseInt(kidsNumber, 10);

  var handleAdultsNumber = function handleAdultsNumber(e) {
    var updatedAdultsNumber = e.target.value;
    var updatedAdultsInt = parseInt(updatedAdultsNumber, 10);
    var newAdults = updatedAdultsInt - adultsInt;
    var updatedAdults = newAdults > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(Array(newAdults).fill(null).map(function () {
      return DEFAULT_COMPANION;
    }))) : adults.slice(0, updatedAdultsInt - 1);
    setValues(PrebookingFormProject_objectSpread(PrebookingFormProject_objectSpread({}, values), {}, {
      adultsNumber: updatedAdultsNumber,
      adults: updatedAdults
    }));
  };

  var handleKidsNumber = function handleKidsNumber(e) {
    var updatedKidsNumber = e.target.value;
    var updatedKidsInt = parseInt(updatedKidsNumber, 10);
    var newKids = updatedKidsInt - kidsInt;
    var updatedKids = newKids > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(kids), Object(toConsumableArray["a" /* default */])(Array(newKids).fill(null).map(function () {
      return DEFAULT_COMPANION;
    }))) : kids.slice(0, updatedKidsInt);
    setValues(PrebookingFormProject_objectSpread(PrebookingFormProject_objectSpread({}, values), {}, {
      kidsNumber: updatedKidsNumber,
      kids: updatedKids
    }));
  };

  var sortedOpeningDates = Object(toConsumableArray["a" /* default */])((product === null || product === void 0 ? void 0 : product.openingDates) || []).sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  });

  var firstOpeningDate = (_sortedOpeningDates$ = sortedOpeningDates[0]) === null || _sortedOpeningDates$ === void 0 ? void 0 : _sortedOpeningDates$.opening;
  var lastClosingDate = (_sortedOpeningDates = sortedOpeningDates[sortedOpeningDates.length - 1]) === null || _sortedOpeningDates === void 0 ? void 0 : _sortedOpeningDates.closing; // Use product-specific departureDateStart if available, otherwise use global departureDateStart

  var productDepartureDateStart = product === null || product === void 0 ? void 0 : product.departureDateStart;
  var hasProductSpecificStartDate = productDepartureDateStart && moment_default()(productDepartureDateStart, 'YYYY-MM-DD').isValid();
  var effectiveDepartureDateStart = hasProductSpecificStartDate ? moment_default()(productDepartureDateStart, 'YYYY-MM-DD').toDate() : departureDateStart; // Use product-specific departureDateEnd if available (absolute), otherwise use global departureDateEnd with API comparison

  var productDepartureDateEnd = product === null || product === void 0 ? void 0 : product.departureDateEnd;
  var hasProductSpecificEndDate = productDepartureDateEnd && moment_default()(productDepartureDateEnd, 'YYYY-MM-DD').isValid(); // Calculate disabled days - if product has specific dates, don't disable days within that range

  var disabledDays = Object(calendar_helper["b" /* getClosingDatesRanges */])(sortedOpeningDates); // If product has specific end date, remove the last closing range that would block dates after lastClosingDate

  if (hasProductSpecificEndDate && disabledDays.length > 0) {
    // Remove the last disabled range (which blocks dates after the last closing date)
    disabledDays = disabledDays.slice(0, -1);
  }

  var minDate;

  if (hasProductSpecificStartDate) {
    minDate = effectiveDepartureDateStart;
  } else if (firstOpeningDate && Object(apiDate["j" /* momentFromApiDate */])(firstOpeningDate).isAfter(moment_default()(effectiveDepartureDateStart))) {
    minDate = Object(apiDate["j" /* momentFromApiDate */])(firstOpeningDate).toDate();
  } else {
    minDate = effectiveDepartureDateStart;
  } // If product has a specific departureDateEnd, use it as absolute date (no comparison with API dates)
  // Otherwise, use global departureDateEnd but limit it to lastClosingDate from API if needed


  var maxDate;

  if (hasProductSpecificEndDate) {
    maxDate = moment_default()(productDepartureDateEnd, 'YYYY-MM-DD').toDate();
  } else if (lastClosingDate && moment_default()(departureDateEnd).isAfter(Object(apiDate["j" /* momentFromApiDate */])(lastClosingDate))) {
    maxDate = Object(apiDate["j" /* momentFromApiDate */])(lastClosingDate).toDate();
  } else {
    maxDate = departureDateEnd;
  }

  var isClosed = !!lastClosingDate && Object(apiDate["j" /* momentFromApiDate */])(lastClosingDate).isBefore(moment_default()());
  var filterOptions = [{
    value: 'sun',
    label: Object(i18n["h" /* t */])('prebookingForm.stay.filterSun', {
      defaultValue: 'Sun'
    })
  }, {
    value: 'snow',
    label: Object(i18n["h" /* t */])('prebookingForm.stay.filterSnow', {
      defaultValue: 'Snow'
    })
  }];

  var handleFilterChange = function handleFilterChange(value) {
    // $FlowFixMe - value is validated by TabLikeFilters options ('sun' | 'snow')
    setProductFilterType(value); // Track filter click when a filter is selected

    if (value) {
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FILTERS, {
        detail_click: value
      });
    }
  };

  return PrebookingFormProject_jsx("div", {
    id: "pbf-step-0",
    "data-testid": "prebooking-form-form-project"
  }, showFiltersSunSnow && PrebookingFormProject_jsx(react_default.a.Fragment, null, PrebookingFormProject_jsx("h3", {
    className: "mb-10 mt-20 px-10 text-18 font-bold"
  }, Object(i18n["h" /* t */])('prebookingForm.stay.filterTitle', {
    defaultValue: 'Type of destination'
  })), PrebookingFormProject_jsx(TabLikeFilters_TabLikeFilters, {
    options: filterOptions,
    selectedValue: productFilterType,
    onChange: handleFilterChange,
    dataTestId: "product-filter-tabs",
    additionalClassNames: "w-full md:w-1/2"
  })), PrebookingFormProject_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4",
    id: "pbf-step-0-title"
  }, Object(i18n["h" /* t */])('prebookingForm.stay.title')), PrebookingFormProject_jsx("p", {
    className: "m-0 mb-10 px-10 text-12"
  }, Object(i18n["h" /* t */])('prebookingForm.mandatoryFieldsInformation')), PrebookingFormProject_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "product-id-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.stay.productLabel'),
    name: "productId",
    options: filteredProductOptions,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.stay.productPlaceholder'),
    type: "select",
    isDisabled: isDisabled
  }), minAuthorizedAge ? PrebookingFormProject_jsx(Notification["a" /* Notification */], {
    className: "mt-15 rounded-12 px-20 py-0",
    text: minAuthorizedAge,
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }) : null, isSki ? PrebookingFormProject_jsx(Notification["a" /* Notification */], {
    className: "mt-15 rounded-12 px-20 py-0",
    text: Object(i18n["h" /* t */])('prebookingForm.stay.dateSkiResortInformation'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }) : null, isSAFC ? PrebookingFormProject_jsx(Notification["a" /* Notification */], {
    className: "mt-15 rounded-12 px-20 py-0",
    text: Object(i18n["h" /* t */])('prebookingForm.stay.safcResortInformation'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }) : null, isCOLC ? PrebookingFormProject_jsx(Notification["a" /* Notification */], {
    className: "mt-15 rounded-12 px-20 py-0",
    text: Object(i18n["h" /* t */])('prebookingForm.stay.colcResortInformation'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }) : null, isCSCK ? PrebookingFormProject_jsx(Notification["a" /* Notification */], {
    className: "mt-15 rounded-12 px-20 py-0",
    text: Object(i18n["h" /* t */])('prebookingForm.stay.cskcResortInformation'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }) : null, isBOKC ? PrebookingFormProject_jsx(Notification["a" /* Notification */], {
    className: "mt-15 rounded-12 px-20 py-0",
    text: Object(i18n["h" /* t */])('prebookingForm.stay.bokcResortInformation'),
    iconName: icons["a" /* ICONS */].EXCLAMATION_POINT
  }) : null), transportFeatureFlip && PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-city-field",
    hideErrorMessage: true,
    isDisabled: !productId || isDisabled,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.stay.departureCityLabel'),
    name: "departureCity",
    options: transportOptions,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.stay.departureCityPlaceholder'),
    type: "select"
  }))), PrebookingFormProject_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    className: "z-1",
    dataTestId: "departure-date-field",
    dateFormat: dateFormat,
    hideErrorMessage: true,
    isDisabled: !productId || isClosed || isDisabled,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.stay.departureDateLabel'),
    maxDate: maxDate,
    minDate: minDate,
    disabledDays: disabledDays,
    name: "departureDate",
    placeholder: Object(i18n["h" /* t */])('prebookingForm.stay.departureDatePlaceholder'),
    type: "datepicker"
  })), PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "duration-field",
    hideErrorMessage: true,
    isDisabled: !productId || isDisabled,
    isRequired: true,
    label: Object(i18n["h" /* t */])('prebookingForm.stay.durationLabel'),
    name: "duration",
    options: durationOptions,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.stay.durationPlaceholder'),
    type: "select"
  }))), PrebookingFormProject_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "accommodation-category-field",
    label: Object(i18n["h" /* t */])('prebookingForm.stay.accommodationsLabel'),
    hideErrorMessage: true,
    isDisabled: !productId || isDisabled,
    isRequired: true,
    name: "accommodationCategory",
    options: accommodationCategoryOptions,
    placeholder: Object(i18n["h" /* t */])('prebookingForm.stay.accommodationsCategoryPlaceholder'),
    type: "select"
  }))), PrebookingFormProject_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "adults-number-field",
    label: Object(i18n["h" /* t */])('prebookingForm.stay.numberOfAdultsLabel'),
    isRequired: true,
    hideErrorMessage: true,
    name: "adultsNumber",
    options: adultsOptions,
    onChange: handleAdultsNumber,
    type: "select",
    isDisabled: isDisabled
  }))), PrebookingFormProject_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormProject_jsx("div", {
    className: "w-full p-10 md:w-1/2"
  }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-number-field",
    label: Object(i18n["h" /* t */])('prebookingForm.stay.numberOfKidsLabel'),
    hideErrorMessage: true,
    isRequired: true,
    name: "kidsNumber",
    onChange: handleKidsNumber,
    options: kidsOptions,
    type: "select",
    isDisabled: isDisabled
  }))), kids.length > 0 && PrebookingFormProject_jsx("div", {
    className: "flex flex-wrap"
  }, kids.map(function (kid, index) {
    return PrebookingFormProject_jsx("div", {
      key: kid.value,
      className: "w-full p-10 md:w-1/2"
    }, PrebookingFormProject_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "kids-".concat(index, "-birthdate-field"),
      hideErrorMessage: !minAuthorizedAge,
      isRequired: true,
      label: Object(i18n["h" /* t */])('prebookingForm.pax.childBirthDateInformationLabel_n', {
        children: index + 1
      }),
      name: "kids.".concat(index, ".birthdate"),
      placeholder: Object(i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
      type: "birthdate",
      dayPlaceholder: "DD",
      monthPlaceholder: "MM",
      yearPlaceholder: "YYYY",
      dateFormat: dateFormat,
      validate: PrebookingForm_utils_getKidFutureBithdateValidator(minAuthorizedAgeInMonths, minAuthorizedAge),
      isDisabled: isDisabled
    }));
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormSearchButton.jsx
















var PrebookingFormSearchButton_jsx = react_default.a.createElement;












var PrebookingFormSearchButton_PrebookingFormSearchButton = function PrebookingFormSearchButton(_ref) {
  var product = _ref.product,
      setProposal = _ref.setProposal,
      setIsLoading = _ref.setIsLoading,
      setFormStep = _ref.setFormStep,
      setFetchProposalError = _ref.setFetchProposalError;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values,
      setTouched = _useFormikContext.setTouched;

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var computeFormValues = function computeFormValues() {
    var _accommodationCategor;

    var kidsKnownAttendeesInformation = values.kids.map(function (kid) {
      return {
        customerId: '',
        birthdate: kid.birthdate
      };
    });
    var adultsKnownAttendeesInformation = values.adults.map(function () {
      return {
        customerId: '',
        birthdate: ''
      };
    });
    var accommodationCategoryOptions = product ? product.accommodations : [];
    var accommodationIds = (_accommodationCategor = accommodationCategoryOptions.find(function (accommodationCategory) {
      return accommodationCategory.value === values.accommodationCategory;
    })) === null || _accommodationCategor === void 0 ? void 0 : _accommodationCategor.types.map(function (accommodation) {
      return accommodation.value;
    });
    var knownAttendeesInformation = [].concat(Object(toConsumableArray["a" /* default */])(adultsKnownAttendeesInformation), Object(toConsumableArray["a" /* default */])(kidsKnownAttendeesInformation));
    return {
      departureCity: values.departureCity,
      numberAttendees: Number(values.kidsNumber) + Number(values.adultsNumber) || 1,
      knownAttendeesInformation: knownAttendeesInformation,
      productId: values.productId,
      arrivalDate: Object(apiDate["m" /* momentToApiDate */])(moment_default()(values.departureDate.from)),
      duration: values.duration,
      fetchActivityCategories: false,
      kids: values.kids.map(function (kid) {
        return {
          birthdate: kid.birthdate,
          childcareIncluded: false
        };
      }),
      adults: values.adults.map(function () {
        return {
          birthdate: undefined,
          civility: undefined,
          firstName: undefined,
          lastName: undefined,
          neolid: undefined,
          unicodeFirstName: undefined,
          unicodeLastName: undefined
        };
      }),
      accommodationIds: accommodationIds,
      isPrebookingFormQuery: true
    };
  };

  function fetchProposals() {
    return _fetchProposals.apply(this, arguments);
  }

  function _fetchProposals() {
    _fetchProposals = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var firstStepKeys, errors, hasFirstPartErrors, searchProposalParams, _yield$proposalsQuery, proposals, isFetchProposalsFailed, _proposals$proposals, firstProposal, _proposals$errors, _proposals$errors$, fetchProposalErrorCode;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              firstStepKeys = ['departureDate', 'accommodationCategory', 'adultsNumber', 'kidsNumber', 'departureCity', 'numberAttendees', 'knownAttendeesInformation', 'productId', 'arrivalDate', 'duration'];
              _context.next = 3;
              return setTouched(Object.keys(values).reduce(function (acc, key) {
                if (key === 'kids') {
                  acc[key] = values.kids.map(function () {
                    return {
                      birthdate: true
                    };
                  });
                } else if (firstStepKeys.includes(key)) {
                  acc[key] = true;
                }

                return acc;
              }, {}));

            case 3:
              errors = _context.sent;
              hasFirstPartErrors = errors && Object.keys(errors).some(function (key) {
                return firstStepKeys.includes(key) || key === 'kids' && errors.kids.some(function (kid) {
                  return !!kid.birthdate;
                });
              });

              if (hasFirstPartErrors) {
                _context.next = 17;
                break;
              }

              setIsLoading(true);
              trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
                detail_click: 'estimate_my_stay'
              });
              searchProposalParams = computeFormValues();
              _context.next = 11;
              return Object(proposalQuery["m" /* proposalsQuery */])(searchProposalParams, appContext);

            case 11:
              _yield$proposalsQuery = _context.sent;
              proposals = _yield$proposalsQuery.proposals;
              isFetchProposalsFailed = Object(proposalUtils["p" /* hasFetchProposalsFailed */])(proposals);

              if (!isFetchProposalsFailed) {
                _proposals$proposals = Object(slicedToArray["a" /* default */])(proposals.proposals, 1), firstProposal = _proposals$proposals[0];
                setProposal(firstProposal);
              } else {
                fetchProposalErrorCode = proposals === null || proposals === void 0 ? void 0 : (_proposals$errors = proposals.errors) === null || _proposals$errors === void 0 ? void 0 : (_proposals$errors$ = _proposals$errors[0]) === null || _proposals$errors$ === void 0 ? void 0 : _proposals$errors$.errorCode;

                if (fetchProposalErrorCode) {
                  setFetchProposalError(fetchProposalErrorCode);
                }
              }

              setFormStep(1);
              setIsLoading(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetchProposals.apply(this, arguments);
  }

  return PrebookingFormSearchButton_jsx(Button["a" /* Button */], {
    "data-testid": "prebooking-form-proposal-search-submit",
    onClick: function onClick() {
      return fetchProposals();
    }
  }, Object(i18n["h" /* t */])('prebookingForm.estimativePrice.labelCTA'));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/CriteriaElement.jsx
var CriteriaElement_jsx = react_default.a.createElement;



var CriteriaElement_CriteriaElement = function CriteriaElement(_ref) {
  var iconName = _ref.iconName,
      criteriaLabel = _ref.criteriaLabel,
      criteriaValue = _ref.criteriaValue,
      _ref$isValidCriteria = _ref.isValidCriteria,
      isValidCriteria = _ref$isValidCriteria === void 0 ? true : _ref$isValidCriteria;
  return CriteriaElement_jsx("div", {
    className: "my-10 flex flex-row items-center rounded-12 border-1 px-30 py-15"
  }, CriteriaElement_jsx("div", {
    className: "flex items-center"
  }, CriteriaElement_jsx(Icon["a" /* Icon */], {
    className: "font-bold",
    dataTestid: "CriteriaElement-icon",
    name: iconName,
    isNotSquare: true,
    width: "2em"
  })), CriteriaElement_jsx("div", {
    className: "flex flex-1 flex-col px-15 md:flex-row"
  }, CriteriaElement_jsx("span", {
    "data-testid": "criteriaLabel"
  }, criteriaLabel, " :"), CriteriaElement_jsx("span", {
    "data-testid": "criteriaValue",
    className: "font-bold md:px-5"
  }, criteriaValue)), CriteriaElement_jsx("div", {
    className: "flex items-center"
  }, isValidCriteria ? CriteriaElement_jsx(Icon["a" /* Icon */], {
    className: "text-green",
    dataTestid: "CriteriaElement-icon-checked",
    isNotSquare: true,
    name: icons["a" /* ICONS */].CHECK_FILLED,
    width: "2em"
  }) : CriteriaElement_jsx(Icon["a" /* Icon */], {
    className: "text-red",
    name: icons["a" /* ICONS */].WARNING,
    isNotSquare: true,
    width: "2em",
    dataTestid: "CriteriaElement-icon-crossed"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/FailureEstimationNotice.jsx
var FailureEstimationNotice_jsx = react_default.a.createElement;

var FailureEstimationNotice = function FailureEstimationNotice(_ref) {
  var problemError = _ref.problemError,
      councelDirective = _ref.councelDirective;
  return FailureEstimationNotice_jsx("div", {
    className: "flex flex-col items-center p-30"
  }, FailureEstimationNotice_jsx("span", {
    className: "text-sienna text-center"
  }, problemError), FailureEstimationNotice_jsx("span", {
    className: "font-sans text-center"
  }, councelDirective));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PriceEstimationCostProposal.jsx
var PriceEstimationCostProposal_jsx = react_default.a.createElement;



var NoticeEstimationCostProposal = function NoticeEstimationCostProposal(_ref) {
  var notice = _ref.notice;
  return PriceEstimationCostProposal_jsx("div", {
    className: "flex justify-center"
  }, PriceEstimationCostProposal_jsx("span", {
    className: "rounded-24 border-0 bg-lightSand px-30 py-5 text-center text-16 font-bold text-sienna",
    "data-testid": "noticeEstimationCost"
  }, notice));
};

var PriceEstimationCostProposal_PriceEstimationCostProposal = function PriceEstimationCostProposal(_ref2) {
  var total = _ref2.total,
      totalWithoutDiscount = _ref2.totalWithoutDiscount,
      productId = _ref2.productId;

  if (!total || !totalWithoutDiscount) {
    return null;
  }

  var isSAFC = productId === 'SAFC';
  return PriceEstimationCostProposal_jsx("div", {
    className: "my-30"
  }, PriceEstimationCostProposal_jsx("div", null, PriceEstimationCostProposal_jsx("div", {
    className: "flex justify-center text-center text-16"
  }, PriceEstimationCostProposal_jsx("span", null, Object(i18n["h" /* t */])('prebookingForm.estimativePrice.confirmation'))), PriceEstimationCostProposal_jsx("div", {
    className: "mb-30 flex justify-center"
  }, PriceEstimationCostProposal_jsx("span", {
    className: "m-5 self-center text-center text-16 font-bold text-sienna line-through",
    "data-testid": "totalWithoutDiscount"
  }, totalWithoutDiscount), PriceEstimationCostProposal_jsx("span", {
    className: "m-5 text-center font-sans text-20 font-bold underline",
    "data-testid": "totalWithDiscount"
  }, total)), isSAFC ? PriceEstimationCostProposal_jsx(NoticeEstimationCostProposal, {
    notice: Object(i18n["h" /* t */])('prebookingForm.estimativePrice.safcEstimativePrice') || ''
  }) : PriceEstimationCostProposal_jsx(NoticeEstimationCostProposal, {
    notice: Object(i18n["h" /* t */])('prebookingForm.estimativePrice.reinsuranceInformation') || ''
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/EstimationCostProposal.jsx







var EstimationCostProposal_jsx = react_default.a.createElement;









var FETCH_PROPOSAL_ERRORS = {
  noTransport: 'noTransport',
  notOnSaleForThePeriod: 'notOnSaleForThePeriod',
  noAccommodation: 'noAccommodation',
  noPrice: 'noPrice'
};

var EstimationCostProposal_getCouncelDirectiveByError = function getCouncelDirectiveByError(error) {
  switch (error) {
    case FETCH_PROPOSAL_ERRORS.noTransport:
      return Object(i18n["h" /* t */])('prebookingForm.estimativePrice.noTransportAvailable');

    case FETCH_PROPOSAL_ERRORS.notOnSaleForThePeriod:
      return Object(i18n["h" /* t */])('prebookingForm.estimativePrice.noDatesAvailable');

    case FETCH_PROPOSAL_ERRORS.noAccommodation:
      return Object(i18n["h" /* t */])('prebookingForm.estimativePrice.noRoomAvailable');

    case FETCH_PROPOSAL_ERRORS.noPrice:
      return Object(i18n["h" /* t */])('prebookingForm.estimativePrice.noPriceAvailable');

    default:
      return '';
  }
};

var EstimationCostProposal_EstimationCostProposal = function EstimationCostProposal(_ref) {
  var _product$accommodatio, _product$accommodatio2, _departureCities$find, _product$destination, _values$departureDate, _proposal$price, _proposal$price$total, _proposal$price2, _proposal$price2$tota;

  var proposal = _ref.proposal,
      product = _ref.product,
      fetchProposalError = _ref.fetchProposalError,
      _ref$departureCities = _ref.departureCities,
      departureCities = _ref$departureCities === void 0 ? [] : _ref$departureCities;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      values = _useFormikContext.values;

  var accommodationCategoryLabel = product === null || product === void 0 ? void 0 : (_product$accommodatio = product.accommodations) === null || _product$accommodatio === void 0 ? void 0 : (_product$accommodatio2 = _product$accommodatio.find(function (_ref2) {
    var value = _ref2.value;
    return value === (values === null || values === void 0 ? void 0 : values.accommodationCategory);
  })) === null || _product$accommodatio2 === void 0 ? void 0 : _product$accommodatio2.name;
  var departureCityLabel = (values === null || values === void 0 ? void 0 : values.departureCity) === 'NO' ? Object(i18n["h" /* t */])('prebookingForm.estimativePrice.noTransportation') : ((_departureCities$find = departureCities.find(function (_ref3) {
    var value = _ref3.value;
    return value === (values === null || values === void 0 ? void 0 : values.departureCity);
  })) === null || _departureCities$find === void 0 ? void 0 : _departureCities$find.name) || '';
  return EstimationCostProposal_jsx("div", {
    id: "pbf-step-1"
  }, EstimationCostProposal_jsx(Title["a" /* Title */], {
    className: "mb-5 mt-30 px-10",
    hLevel: 3,
    theme: "title-sans-n4",
    id: "pbf-step-1-title"
  }, "2. ", Object(i18n["h" /* t */])('prebookingForm.estimativePrice.title')), EstimationCostProposal_jsx("div", null, (proposal === null || proposal === void 0 ? void 0 : proposal.id) && EstimationCostProposal_jsx("div", {
    className: "flex gap-5"
  }, EstimationCostProposal_jsx("h3", null, Object(i18n["h" /* t */])('prebookingForm.estimativePrice.proposalNumber')), EstimationCostProposal_jsx("span", {
    className: "font-bold"
  }, " ", (proposal === null || proposal === void 0 ? void 0 : proposal.id) || '')), EstimationCostProposal_jsx("div", null, EstimationCostProposal_jsx(CriteriaElement_CriteriaElement, {
    iconName: icons["a" /* ICONS */].EARTH,
    criteriaLabel: Object(i18n["h" /* t */])('prebookingForm.stay.productLabel'),
    criteriaValue: "".concat((product === null || product === void 0 ? void 0 : product.name) || '', ", ").concat((product === null || product === void 0 ? void 0 : (_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country) || ''),
    isValidCriteria: true
  }), EstimationCostProposal_jsx(CriteriaElement_CriteriaElement, {
    iconName: icons["a" /* ICONS */].PLANE_V2,
    criteriaLabel: Object(i18n["h" /* t */])('prebookingForm.stay.departureCityLabel'),
    criteriaValue: departureCityLabel,
    isValidCriteria: fetchProposalError !== FETCH_PROPOSAL_ERRORS.noTransport
  }), EstimationCostProposal_jsx(CriteriaElement_CriteriaElement, {
    iconName: icons["a" /* ICONS */].CALENDAR_EMPTY,
    criteriaLabel: Object(i18n["h" /* t */])('prebookingForm.stay.durationLabel'),
    criteriaValue: "".concat(Object(dateUtils["h" /* momentFromUTCDateTime */])(values === null || values === void 0 ? void 0 : (_values$departureDate = values.departureDate) === null || _values$departureDate === void 0 ? void 0 : _values$departureDate.from).format('DD/MM/YYYY') || '', " (").concat(Object(i18n["h" /* t */])('prebookingForm.stay.durationValue', {
      count: values === null || values === void 0 ? void 0 : values.duration
    }), ")"),
    isValidCriteria: fetchProposalError !== FETCH_PROPOSAL_ERRORS.notOnSaleForThePeriod
  }), EstimationCostProposal_jsx(CriteriaElement_CriteriaElement, {
    iconName: icons["a" /* ICONS */].BED,
    criteriaLabel: Object(i18n["h" /* t */])('prebookingForm.stay.accommodationsLabel'),
    criteriaValue: accommodationCategoryLabel,
    isValidCriteria: fetchProposalError !== FETCH_PROPOSAL_ERRORS.noAccommodation
  }), EstimationCostProposal_jsx(CriteriaElement_CriteriaElement, {
    iconName: icons["a" /* ICONS */].PEOPLE_DOUBLE,
    criteriaLabel: Object(i18n["h" /* t */])('prebookingForm.stay.numberOfParticipantsLabel'),
    criteriaValue: "".concat(Object(i18n["h" /* t */])('prebookingForm.stay.adultsAge', {
      count: Number(values === null || values === void 0 ? void 0 : values.adultsNumber) || 0
    }), " - ").concat(Object(i18n["h" /* t */])('prebookingForm.stay.childrenAge', {
      count: Number(values === null || values === void 0 ? void 0 : values.kidsNumber) || 0
    }))
  }), (proposal === null || proposal === void 0 ? void 0 : proposal.price) ? EstimationCostProposal_jsx(PriceEstimationCostProposal_PriceEstimationCostProposal, {
    productId: product === null || product === void 0 ? void 0 : product.productId,
    total: proposal === null || proposal === void 0 ? void 0 : (_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : (_proposal$price$total = _proposal$price.total) === null || _proposal$price$total === void 0 ? void 0 : _proposal$price$total.formattedValue,
    totalWithoutDiscount: proposal === null || proposal === void 0 ? void 0 : (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : (_proposal$price2$tota = _proposal$price2.totalWithoutDiscount) === null || _proposal$price2$tota === void 0 ? void 0 : _proposal$price2$tota.formattedValue
  }) : EstimationCostProposal_jsx(FailureEstimationNotice, {
    problemError: Object(i18n["h" /* t */])('prebookingForm.estimativePrice.notAvailable'),
    councelDirective: EstimationCostProposal_getCouncelDirectiveByError(fetchProposalError)
  }))));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/ModifyButton.jsx
var ModifyButton_jsx = react_default.a.createElement;






var ModifyButton_ModifyButton = function ModifyButton(_ref) {
  var hasPrice = _ref.hasPrice,
      formStep = _ref.formStep,
      setFormStep = _ref.setFormStep,
      resetProposal = _ref.resetProposal;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  var modifyAction = function modifyAction() {
    var detailClick = '';

    if (formStep === 1) {
      detailClick = 'modify_stay_step';
    } else if (formStep === 2) {
      detailClick = 'modify_participants_step';
    } else {
      detailClick = hasPrice ? 'modify_estimation_step_with_price' : 'modify_estimation_step_without_price';
    }

    trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
      detail_click: detailClick
    });
    resetProposal();
    setFormStep(0);
  };

  return ModifyButton_jsx(Button["a" /* Button */], {
    key: "prebooking-modify",
    id: "prebooking-modify",
    className: "mx-10",
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].BLACK,
    onClick: modifyAction
  }, Object(i18n["h" /* t */])('prebookingForm.modifyRequest'));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/ActionsEstimationCostProposal.jsx
var ActionsEstimationCostProposal_jsx = react_default.a.createElement;








var ActionsEstimationCostProposal_ActionsEstimationCostProposal = function ActionsEstimationCostProposal(_ref) {
  var hasPrice = _ref.hasPrice,
      formStep = _ref.formStep,
      setFormStep = _ref.setFormStep,
      resetProposal = _ref.resetProposal;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isSubmitting = _useFormikContext.isSubmitting;

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return ActionsEstimationCostProposal_jsx("div", {
    className: "flex flex-col justify-center space-y-15 md:flex-row md:space-y-0"
  }, ActionsEstimationCostProposal_jsx(ModifyButton_ModifyButton, {
    hasPrice: hasPrice,
    formStep: formStep,
    setFormStep: setFormStep,
    resetProposal: resetProposal
  }), formStep === 2 ? ActionsEstimationCostProposal_jsx(Button["a" /* Button */], {
    key: "prebooking-submit",
    id: "prebooking-submit",
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_RIGHT
    },
    className: "bg-primary mx-10",
    "data-testid": "prebooking-submit",
    isLoading: isSubmitting,
    type: "submit"
  }, Object(i18n["h" /* t */])('prebookingForm.sendRequest')) : ActionsEstimationCostProposal_jsx(Button["a" /* Button */], {
    key: "prebooking-continue",
    id: "prebooking-continue",
    className: "bg-primary mx-10",
    onClick: function onClick() {
      var detailClick = hasPrice ? 'continue_with_price' : 'continue_without_price';
      trackClickEvent(constants["F" /* TRACK_EVENT_NAMES */].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: detailClick
      });
      setFormStep(2);
    }
  }, Object(i18n["h" /* t */])('prebookingForm.continueRequest')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.jsx





var PrebookingForm_jsx = react_default.a.createElement;













var PrebookingForm_PrebookingForm = function PrebookingForm(_ref) {
  var adultsOptions = _ref.adultsOptions,
      agencies = _ref.agencies,
      civilities = _ref.civilities,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      formStep = _ref.formStep,
      hasError = _ref.hasError,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      kidsOptions = _ref.kidsOptions,
      consentOptins = _ref.consentOptins,
      productOptions = _ref.productOptions,
      products = _ref.products,
      proposal = _ref.proposal,
      setProposal = _ref.setProposal,
      setFormStep = _ref.setFormStep,
      setHasError = _ref.setHasError;
  var formik = Object(formik_esm["e" /* useFormikContext */])();
  var values = formik.values,
      setFieldValue = formik.setFieldValue;

  var _useState = Object(react["useState"])(null),
      fetchProposalError = _useState[0],
      setFetchProposalError = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var productId = values.productId;
  var product = productId ? products[productId] : null;
  Object(ScrollToErrorHook["a" /* useAutoScrollToError */])(formik);
  Object(react["useEffect"])(function () {
    var _products$productId;

    var departureDate = values.departureDate.from;

    if (productId && departureDate && !((_products$productId = products[productId]) === null || _products$productId === void 0 ? void 0 : _products$productId.openingDates.some(function (_ref2) {
      var opening = _ref2.opening,
          closing = _ref2.closing;
      return moment_default()(departureDate).isBetween(Object(apiDate["j" /* momentFromApiDate */])(opening), Object(apiDate["j" /* momentFromApiDate */])(closing));
    }))) {
      setFieldValue('departureDate', {
        from: null,
        to: null
      });
    }
  }, [productId]);
  Object(react["useEffect"])(function () {
    var accommodationCategory = values.accommodationCategory,
        departureCity = values.departureCity,
        duration = values.duration;

    if (product) {
      var _product$accommodatio, _product$transports, _product$durations;

      var accomodationInProduct = (_product$accommodatio = product.accommodations) === null || _product$accommodatio === void 0 ? void 0 : _product$accommodatio.find(function (accomodation) {
        return accomodation.value === accommodationCategory;
      });
      var transportInProduct = (_product$transports = product.transports) === null || _product$transports === void 0 ? void 0 : _product$transports.find(function (transport) {
        return transport.value === departureCity;
      });
      var durationsInProduct = (_product$durations = product.durations) === null || _product$durations === void 0 ? void 0 : _product$durations.find(function (dur) {
        return dur.value === duration;
      });

      if (!accomodationInProduct) {
        var firstProductAccomodationCategory = product.accommodations[0].value;
        setFieldValue('accommodationCategory', firstProductAccomodationCategory);
      }

      if (!transportInProduct) {
        var firstProductTransport = product.transports[0].value;
        setFieldValue('departureCity', firstProductTransport);
      }

      if (!durationsInProduct) {
        var firstProductDuration = product.durations[0].value;
        setFieldValue('duration', firstProductDuration);
      }
    }
  }, [product]);
  Object(react["useEffect"])(function () {
    if (agencies && agencies.length === 1) {
      setFieldValue('agency', agencies[0].value);
    }
  }, [agencies]);

  var resetProposal = function resetProposal() {
    setHasError(false);
    setProposal(null);
    setFetchProposalError(null);
  };

  return PrebookingForm_jsx(formik_esm["c" /* Form */], {
    id: "prebooking-form-form",
    "data-testid": "prebooking-form-form"
  }, PrebookingForm_jsx(PrebookingFormProject_PrebookingFormProject, {
    adultsOptions: adultsOptions,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    kidsOptions: kidsOptions,
    productOptions: productOptions,
    product: product,
    products: products,
    isDisabled: formStep > 0 || isLoading
  }), isLoading && PrebookingForm_jsx("div", {
    className: "pbf-loader mt-20 block w-full"
  }, PrebookingForm_jsx(AsyncLoader["a" /* AsyncLoader */], null), PrebookingForm_jsx("p", {
    className: "mt-20 text-center text-16"
  }, Object(i18n["h" /* t */])('prebookingForm.estimativePrice.loaderLabel'))), !isLoading && formStep === 0 && PrebookingForm_jsx("div", {
    className: "my-10 flex w-full justify-center"
  }, PrebookingForm_jsx(PrebookingFormSearchButton_PrebookingFormSearchButton, {
    setProposal: setProposal,
    setIsLoading: setIsLoading,
    product: product,
    setFormStep: setFormStep,
    setFetchProposalError: setFetchProposalError
  })), formStep > 0 && PrebookingForm_jsx("div", {
    className: "my-10 flex w-full justify-center"
  }, PrebookingForm_jsx(ModifyButton_ModifyButton, {
    hasPrice: !!(proposal === null || proposal === void 0 ? void 0 : proposal.price),
    formStep: formStep,
    setFormStep: setFormStep,
    resetProposal: resetProposal
  })), PrebookingForm_jsx("div", null, formStep >= 1 && PrebookingForm_jsx(EstimationCostProposal_EstimationCostProposal, {
    proposal: proposal,
    product: product,
    fetchProposalError: fetchProposalError,
    departureCities: (product === null || product === void 0 ? void 0 : product.transports) || []
  }), formStep === 2 && PrebookingForm_jsx(PrebookingFormTravelInformations_PrebookingFormTravelInformations, {
    agencies: agencies,
    civilities: civilities,
    dateFormat: dateFormat,
    hasUnicodeFields: hasUnicodeFields,
    hasUser: hasUser,
    consentOptins: consentOptins
  }), hasError && PrebookingForm_jsx("div", {
    className: "mb-20 mt-40 w-full"
  }, PrebookingForm_jsx("p", {
    className: "text-center text-16 font-semibold text-red"
  }, Object(i18n["h" /* t */])('prebookingForm.submitError'))), formStep > 0 && PrebookingForm_jsx(ActionsEstimationCostProposal_ActionsEstimationCostProposal, {
    hasPrice: !!(proposal === null || proposal === void 0 ? void 0 : proposal.price),
    formStep: formStep,
    setFormStep: setFormStep,
    resetProposal: resetProposal
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormContainer.jsx

















var PrebookingFormContainer_jsx = react_default.a.createElement;


function PrebookingFormContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingFormContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingFormContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingFormContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function PrebookingFormContainer(_ref) {
  var adultsOptions = _ref.adultsOptions,
      agencies = _ref.agencies,
      civilities = _ref.civilities,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      kidsOptions = _ref.kidsOptions,
      consentOptins = _ref.consentOptins,
      productOptions = _ref.productOptions,
      products = _ref.products,
      redirectUris = _ref.redirectUris;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var productId = router.query.productId;
  var productIdRef = Object(react["useRef"])(null);

  var _React$useState = react_default.a.useState(null),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      proposal = _React$useState2[0],
      setProposal = _React$useState2[1];

  var _React$useState3 = react_default.a.useState(0),
      _React$useState4 = Object(slicedToArray["a" /* default */])(_React$useState3, 2),
      formStep = _React$useState4[0],
      setFormStep = _React$useState4[1];

  var _React$useState5 = react_default.a.useState(false),
      _React$useState6 = Object(slicedToArray["a" /* default */])(_React$useState5, 2),
      hasError = _React$useState6[0],
      setHasError = _React$useState6[1];

  var scrollToFormStep = function scrollToFormStep(step) {
    var attemptCount = 0;
    var maxAttempts = 5;

    var checkStepAndScroll = function checkStepAndScroll() {
      attemptCount += 1;
      var formStepElement = document.getElementById("pbf-step-".concat(step, "-title"));

      if (formStepElement) {
        Object(scrollToElement["a" /* scrollToElement */])("#pbf-step-".concat(step, "-title"), 500, '.pbf-loader', false, step === 1 ? 50 : 0);
      } else if (attemptCount < maxAttempts) {
        setTimeout(checkStepAndScroll, 100);
      }
    };

    setFormStep(step);
    checkStepAndScroll();
  };

  var redirects = {
    errorUrl: redirectUris.error || '/',
    successUrl: redirectUris.success || '/'
  };
  var productIds = productOptions.map(function (productOption) {
    return productOption.value;
  }).filter(Boolean);

  var _useTrackEvent = Object(useTrackEvent["a" /* useTrackEvent */])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  Object(react["useEffect"])(function () {
    if (productId) {
      productIdRef.current = productId;
      var newUri = new URI_default.a(router.asPath).removeQuery(['productId']);
      router.replace(newUri.toString(), undefined, {
        shallow: true
      });
    }
  }, []);

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var _productOptions$find, _productOptions$;

    var userInfo = state.userInfo;
    var intialProductId = ((_productOptions$find = productOptions.find(function (product) {
      return product.value === productIdRef.current;
    })) === null || _productOptions$find === void 0 ? void 0 : _productOptions$find.value) || ((_productOptions$ = productOptions[0]) === null || _productOptions$ === void 0 ? void 0 : _productOptions$.value) || '';
    return {
      initialFormData: PrebookingFormContainer_objectSpread({
        productId: intialProductId,
        traveler: getFormUser(userInfo)
      }, getFormOptins(userInfo, consentOptins))
    };
  }),
      initialFormData = _useSelector.initialFormData;

  var schema = PrebookingForm_utils_getFormSchema(i18n["h" /* t */], {
    agencies: agencies.map(function (agency) {
      return agency.value;
    }),
    civilities: civilities,
    locale: appContext.locale,
    productIds: productIds
  }, formStep);
  return PrebookingFormContainer_jsx(formik_esm["d" /* Formik */], {
    initialValues: PrebookingForm_utils_getInitialFormValues(initialFormData),
    validationSchema: schema,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", handleSubmit(values, {
                  appContext: appContext,
                  dateFormat: dateFormat,
                  redirects: redirects,
                  router: router,
                  trackClickEvent: trackClickEvent,
                  setHasError: setHasError,
                  proposalId: proposal === null || proposal === void 0 ? void 0 : proposal.id,
                  proposalPrice: proposal === null || proposal === void 0 ? void 0 : proposal.price
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, PrebookingFormContainer_jsx(PrebookingForm_PrebookingForm, {
    adultsOptions: adultsOptions,
    agencies: agencies,
    civilities: civilities,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    hasError: hasError,
    hasUnicodeFields: hasUnicodeFields,
    hasUser: hasUser,
    kidsOptions: kidsOptions,
    consentOptins: consentOptins,
    productOptions: productOptions,
    products: products,
    proposal: proposal,
    setProposal: setProposal,
    formStep: formStep,
    setFormStep: scrollToFormStep,
    setHasError: setHasError
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.jsx
var PrebookingFormLine_jsx = react_default.a.createElement;









var PrebookingFormLine_PrebookingFormLine = function PrebookingFormLine(props) {
  var _config$account, _config$account$authe;

  var accommodationCategories = props.accommodationCategories,
      bookingsCriteria = props.bookingsCriteria,
      adultCivilities = props.civilities,
      config = props.config,
      dateFormat = props.dateFormat,
      error = props.error,
      legalInformations = props.legalInformations,
      login = props.login,
      mainTraveler = props.mainTraveler,
      mandatoryFieldsInformation = props.mandatoryFieldsInformation,
      pax = props.pax,
      products = props.products,
      resorts = props.resorts,
      sendRequest = props.sendRequest,
      stay = props.stay,
      success = props.success,
      travelAgencies = props.travelAgencies,
      estimativePrice = props.estimativePrice,
      modifyRequest = props.modifyRequest,
      continueRequest = props.continueRequest,
      submitError = props.submitError;
  Object(i18n["a" /* addTranslationKeys */])({
    prebookingForm: {
      login: login,
      mainTraveler: mainTraveler,
      mandatoryFieldsInformation: mandatoryFieldsInformation,
      pax: pax,
      sendRequest: sendRequest,
      stay: stay,
      estimativePrice: estimativePrice,
      modifyRequest: modifyRequest,
      continueRequest: continueRequest,
      submitError: submitError
    }
  });
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var hasUnicodeFields = appContext.displayUnicodeFields,
      locale = appContext.locale,
      hasUser = appContext.isUserLogged; // force scroll to top on page load

  if (true) {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  } // CXO: set seller agency and id


  var agencies = Object(PrebookingFormLine_utils["h" /* getTravelAgencyOptions */])(travelAgencies, locale);
  var civilities = Object(PrebookingFormLine_utils["c" /* getCivilities */])(adultCivilities.adult, locale);
  var hasLoginButton = !!((_config$account = config.account) === null || _config$account === void 0 ? void 0 : (_config$account$authe = _config$account.authenticated) === null || _config$account$authe === void 0 ? void 0 : _config$account$authe.greeting);
  var formProducts = Object(PrebookingFormLine_utils["d" /* getFormProducts */])({
    accommodationCategories: accommodationCategories,
    bookingsCriteria: bookingsCriteria,
    resorts: resorts,
    durationLabels: props.stay.durationValue,
    lineProducts: products
  });
  var productOptions = Object(PrebookingFormLine_utils["g" /* getProductOptions */])(products, formProducts);
  var departureDateStart = new Date(props.departureDateStart);
  var departureDateEnd = new Date(props.departureDateEnd);
  var redirectUris = {
    error: error ? error.url : null,
    success: success ? success.url : null
  };
  var adultsOptions = Object(PrebookingFormLine_utils["b" /* getAdultsNumberOptions */])(props.stay.adultsAge);
  var kidsOptions = Object(PrebookingFormLine_utils["e" /* getKidsNumberOptions */])(props.stay.childrenAge);
  var consentOptins = Object(PrebookingFormLine_utils["f" /* getNewsletterOptins */])(legalInformations.bookingProcess || []);
  var loginLabels = {
    memberSpace: Object(i18n["h" /* t */])('prebookingForm.login.memberSpace'),
    memberSpaceTitle: Object(i18n["h" /* t */])('prebookingForm.login.memberSpaceTitle'),
    labelCTA: Object(i18n["h" /* t */])('prebookingForm.login.labelCTA')
  };
  return PrebookingFormLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "prebookingForm",
    id: "prebookingform"
  }, PrebookingFormLine_jsx(TrackPage["a" /* TrackPage */], {
    pageName: constants["H" /* TRACK_PAGE_NAMES */].PREBOOKING_FORM
  }), login.displayLoginIcon && PrebookingFormLine_jsx(CustomerLogin["a" /* CustomerLogin */], {
    hasLoginButton: hasLoginButton,
    hasUser: hasUser,
    labels: loginLabels
  }), PrebookingFormLine_jsx(PrebookingFormContainer, {
    adultsOptions: adultsOptions,
    agencies: agencies,
    civilities: civilities,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    hasUnicodeFields: hasUnicodeFields,
    hasUser: hasUser,
    kidsOptions: kidsOptions,
    locale: locale,
    consentOptins: consentOptins,
    productOptions: productOptions,
    products: formProducts,
    redirectUris: redirectUris
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/prebooking-form/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (PrebookingFormLine_PrebookingFormLine);

/***/ }),

/***/ "tZiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackPage; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tracking_api_useTrackPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Vbjg");


var TrackPage = function TrackPage(_ref) {
  var pageName = _ref.pageName,
      payload = _ref.payload;

  var _useTrackPage = Object(_tracking_api_useTrackPage__WEBPACK_IMPORTED_MODULE_1__[/* useTrackPage */ "a"])(),
      trackPage = _useTrackPage.trackPage;

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    trackPage(pageName, payload);
  }, [pageName]);
  return null;
};

/***/ })

}]);